export default {
    strings: {},
};
